import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AdvertorialPage } from './pages/AdvertorialPage';
const FB_PIXEL_ID = '992624086483436';
function useFacebookPixel(pixelId: string) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    // Initialize the fbq queue without assuming an existing <script> tag exists.
    if (!w.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Append the loader script directly to <head> — robust in any environment.
      const src = 'https://connect.facebook.net/en_US/fbevents.js';
      const alreadyLoaded = Array.from(document.getElementsByTagName('script')).some(el => el.src === src);
      if (!alreadyLoaded) {
        const script = document.createElement('script');
        script.async = true;
        script.src = src;
        const head = document.head || document.documentElement;
        head.appendChild(script);
      }
    }
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
    w.fbq('trackCustom', 'ViewListicle');
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, [pixelId]);
}
export function App() {
  useFacebookPixel(FB_PIXEL_ID);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/5-razones" element={<AdvertorialPage data-id="element-3" />} data-id="element-2" />
        <Route path="/adios-barriga" element={<AdvertorialPage data-id="element-5" />} data-id="element-4" />
        <Route path="*" element={<Navigate to="/adios-barriga" replace data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}